module.exports = __webpack_public_path__ + "static/bridge-d1e7d1d23e053d6d779d1812ce4d9233.png";